import React, { useEffect, useState } from 'react';
import { Grid, useMediaQuery, Typography, Tooltip, Button, Divider, Box } from '@mui/material';
import { useTheme } from '@mui/system';
import Confetti from 'react-confetti';
import { InfoOutlined } from '@mui/icons-material';
import { variants } from '../../../../variants/variants';
import UserAvatar from '../../../../common/UserAvatar';
import Carousel from 'react-material-ui-carousel';

const WinnerCard = ({ winner, setSelectedWinner, setOpen }) => {
  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.down('sm'));

  const [hovered, setHovered] = useState(false);
  const cardRef = React.useRef(null);
  const [confettiSize, setConfettiSize] = useState({ width: 0, height: 0 });

  useEffect(() => {
    const updateSize = () => {
      if (cardRef.current) {
        const rect = cardRef.current.getBoundingClientRect();
        setConfettiSize({ width: rect.width, height: rect.height });
      }
    };

    updateSize(); // Initial call

    const resizeObserver = new ResizeObserver(updateSize);
    if (cardRef.current) resizeObserver.observe(cardRef.current);

    return () => resizeObserver.disconnect();
  }, []);

  const handleOverviewClick = () => {
    setSelectedWinner(winner);
    setOpen(true);
  };

  console.log('winner', winner);

  if (!winner) return <>Loading</>;
  return (
    <Grid item xs={12} sm={6} md={3}>
      {winner.isTeamNomination ? (
        <Grid
          ref={cardRef}
          sx={{
            wrap: 'nowrap',
            overflow: 'none',
            border: 1,
            borderColor: 'divider',
            boxShadow: 'none',
            padding: 2,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            position: 'relative',
            borderRadius: '8px',
            textAlign: 'center',
            transition: 'all 0.1s ease-in-out',
            height: isSm ? '35vh' : '35vh',
            '&:hover': {
              transform: 'scale(1.0)',
              boxShadow: variants.BOX_SHADOW,
            },
            m: 1,
          }}
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
        >
          {hovered && (
            <Confetti numberOfPieces={200} width={confettiSize.width} height={confettiSize.height} recycle={true} />
          )}

          <Box
            sx={{ whiteSpace: 'nowrap' }}
            width={'100%'}
            display={'flex'}
            justifyContent={'space-between'}
            alignItems={'center'}
          >
            <Typography
              fontWeight={'bold'}
              sx={{
                [theme.breakpoints.down('sm')]: {
                  fontSize: '0.8rem',
                },
              }}
            >
              Team : {winner.winnerTeam.teamName}
            </Typography>
            <Button onClick={handleOverviewClick}>
              <Tooltip title="Overview">
                <InfoOutlined />
              </Tooltip>
            </Button>
          </Box>
          <Grid item xl={12} width={'100%'} overflow={'hidden'}>
            <Carousel autoPlay interval={2000} sx={{ height: '23vh' }}>
              {winner.winnerTeam?.teamMembers.map((winner, i) => (
                <Box
                  key={i}
                  sx={{
                    // whiteSpace:'nowrap',
                    width: '100%',
                    // backgroundColor:'cyan',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    overflow: 'none',
                    wordWrap: 'break-word',
                  }}
                >
                  <UserAvatar src={winner?.photo} sx={{ width: 80, height: 80, mb: 1, mt: 0 }} />
                  <Typography
                    variant="h6"
                    sx={{
                      mb: isSm ? 0 : 1,
                      overflowWrap: 'break-word',
                      wordWrap: 'break-word',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      [theme.breakpoints.down('sm')]: {
                        fontSize: '1rem',
                      },
                    }}
                  >
                    {winner?.firstName} {winner?.middleName} {winner?.lastName}
                  </Typography>
                  {!isSm && (
                    <Typography
                      variant="subtitle1"
                      color="text.secondary"
                      sx={{
                        mb: 1,
                        overflowWrap: 'break-word',
                        wordWrap: 'break-word',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        [theme.breakpoints.down('sm')]: {
                          fontSize: '0.875rem',
                        },
                      }}
                    >
                      {winner?.winner?.department}
                    </Typography>
                  )}
                  <Typography
                    variant="subtitle1"
                    color="text.secondary"
                    sx={{
                      mb: 0,
                      overflowWrap: 'break-word',
                      wordWrap: 'break-word',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      [theme.breakpoints.down('sm')]: {
                        fontSize: '0.8rem',
                      },
                    }}
                  >
                    {winner?.designation}
                  </Typography>
                </Box>
              ))}
            </Carousel>
            <Divider sx={{ width: '100%', mb: isSm ? 0 : 1 }} />
            <Typography
              sx={{
                overflowWrap: 'break-word',
                wordWrap: 'break-word',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                [theme.breakpoints.down('sm')]: {
                  fontSize: '0.9rem',
                },
                mb: 0,
              }}
              variant="body1"
            >
              {winner?.categoryName}
            </Typography>
          </Grid>
        </Grid>
      ) : (
        <Grid
          ref={cardRef}
          sx={{
            wrap: 'nowrap',
            overflow: 'hidden',
            border: 1,
            borderColor: 'divider',
            boxShadow: 'none',
            padding: 2,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            position: 'relative',
            borderRadius: '8px',
            textAlign: 'center',
            transition: 'all 0.1s ease-in-out',
            height: isSm ? '28vh' : '35vh',
            '&:hover': {
              transform: 'scale(1.0)',
              boxShadow: variants.BOX_SHADOW,
            },
            m: 1,
          }}
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
        >
          {hovered && (
            <Confetti numberOfPieces={200} width={confettiSize.width} height={confettiSize.height} recycle={true} />
          )}
          <Tooltip title="Overview">
            <Button
              onClick={handleOverviewClick}
              sx={{
                position: 'absolute',
                top: theme.spacing(1),
                right: theme.spacing(1),
                zIndex: 1,
              }}
            >
              <InfoOutlined />
            </Button>
          </Tooltip>
          <UserAvatar src={winner?.winner?.photo} sx={{ width: 80, height: 80, mb: 2, mt: 1 }} />
          <Typography
            variant="h6"
            sx={{
              mb: isSm ? 0 : 1,
              overflowWrap: 'break-word',
              wordWrap: 'break-word',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              [theme.breakpoints.down('sm')]: {
                fontSize: '1rem',
              },
            }}
          >
            {winner?.winner?.firstName} {winner?.winner?.middleName} {winner?.winner?.lastName}
          </Typography>

          {!isSm && (
            <Typography
              variant="subtitle1"
              color="text.secondary"
              sx={{
                mb: isSm ? 0 : 1,
                overflowWrap: 'break-word',
                wordWrap: 'break-word',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                [theme.breakpoints.down('sm')]: {
                  fontSize: '0.875rem',
                },
              }}
            >
              {winner?.winner?.department}
            </Typography>
          )}
          <Typography
            variant="subtitle1"
            color="text.secondary"
            sx={{
              mb: 1,
              overflowWrap: 'break-word',
              wordWrap: 'break-word',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              [theme.breakpoints.down('sm')]: {
                fontSize: '0.8rem',
              },
            }}
          >
            {winner?.winner?.designation}
          </Typography>
          <Divider sx={{ width: '100%', mb: isSm ? 0 : 1 }} />
          <Typography
            variant="body1"
            sx={{
              mb: isSm ? 0 : 1,
              mt: isSm ? 1 : 0,
              overflowWrap: 'break-word',
              wordWrap: 'break-word',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              [theme.breakpoints.down('sm')]: {
                fontSize: '0.9rem',
              },
            }}
          >
            {winner?.categoryName}
          </Typography>
        </Grid>
      )}
    </Grid>
  );
};

export default WinnerCard;
